import axios from '@/shared/utils/axios-init';

const initialState = {
  currencyData: [],
  mainCurrenciesData: [],
  currenciesPair: {},

  selectedQuated: 'USDT',
  selectedQuatedTitle: 'Tether',
};


const getters = {
  getCurrencyData(state) {
    return state.currencyData;
  },
  getMainCurrenciesData(state) {
    return state.mainCurrenciesData;
  },
  getCurrenciesPair(state) {
    return state.currenciesPair;
  },
  getSelectedQuated(state) {
    return state.selectedQuated;
  },
  getSelectedQuatedTitle(state) {
    return state.selectedQuatedTitle;
  },
};

const mutations = {
  setCurrencyData(state, data) {
    state.currencyData = data;
  },
  setMainCurrenciesData(state, data) {
    state.mainCurrenciesData = data;
  },
  setSelectedQuated(state, data) {
    state.selectedQuated = data;
  },
  setSelectedQuatedTitle(state, data) {
    state.selectedQuatedTitle = data;
  },

  setCurrenciesPair(state, data) {
    state.currenciesPair = data;
  },

  // from local strorage
  currenciesPairFromLocalStorage(state, currencies) {
    state.currenciesPair = JSON.parse(currencies);
  },
};

const actions = {
  async fetchCurrencyData({ commit }, currency) {
    commit('setCurrencyData', []);

    try {
      const data = await axios.post('/currencies/couple', JSON.stringify({ quoted_code: currency }));
      const currencyData = data.data.list;
      commit('setCurrencyData', currencyData);
      return data;
    } catch (error) {
      return error.response;
    }
  },
  async getMainCurrenciesData({ commit }) {
    try {
      const data = await axios.get('/currencies/quoted');
      const currenciesData = data.data.list;
      commit('setMainCurrenciesData', currenciesData);

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/market.js